import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  palette: {
    primary: { main: '#37AE7C' },
    secondary: { main: '#FFC0CB' }, // Indigo is probably a good match with pink
  },
});
